import * as React from "react"
import {
  Spacer,
  StyledPanelActions,
  StyledPanelBodySection,
  Text,
  ThemeCss,
} from "gatsby-interface"
import { FormElement, FormFields } from "@modules/form/components/Form"

export type ConnectCmsFormLayoutProps = {
  description?: React.ReactNode
  refreshMessage?: React.ReactNode
  instructions?: React.ReactNode
  children: React.ReactNode
  controls: React.ReactNode
}

export function ConnectCmsFormLayout({
  description,
  refreshMessage,
  instructions,
  children,
  controls,
}: ConnectCmsFormLayoutProps) {
  return (
    <FormElement
      css={{
        flexGrow: 1,
        display: `flex`,
        flexDirection: `column`,
      }}
    >
      <div css={{ flexGrow: 1 }}>
        <StyledPanelBodySection>
          <FormFields>
            {description && <Text css={{ margin: 0 }}>{description}</Text>}
            {children}
          </FormFields>
          {refreshMessage || instructions ? <Spacer size={6} /> : null}
          {refreshMessage && <Text>{refreshMessage}</Text>}
          {instructions && <Text>{instructions}</Text>}
        </StyledPanelBodySection>
      </div>
      <StyledPanelActions>{controls}</StyledPanelActions>
    </FormElement>
  )
}

export const loadingContainerCss: ThemeCss = theme => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: theme.space[8],
})
